import { Validators } from '@biteinc/common';
import { SyncableMenuModelSchema } from './syncable_menu_model_schema.js';
export const openHoursOverrideSchema = {
    displayName: 'open hours override',
    type: 'object',
    fields: {
        ...SyncableMenuModelSchema.fields,
        siteId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        name: {
            type: 'keyString',
            isHidden: true,
            isReadOnly: true,
        },
        reason: {
            type: 'keyString',
            required: true,
            validationRegex: Validators.simpleStringRegexString({ allowCommas: true }),
        },
        date: {
            type: 'timestamp',
            required: true,
        },
        fulfillmentMethod: {
            type: 'int',
            required: true,
        },
        schedule: {
            type: 'object',
            subtype: 'Schedule',
            required: true,
        },
        isOpen: {
            type: 'bool',
            required: true,
        },
    },
};
//# sourceMappingURL=open_hours_override_schema.js.map